import { useQuery } from "@tanstack/react-query"

import { supabase } from "@/lib/supabase"
import { UniformIssue } from "@/types/person"

interface FetchUniformOptions {
  driverId?: string
  limit?: number
  offset?: string
}

interface FetchUniformResponse {
  data: UniformIssue[]
  offset?: string
}

/**
 * Custom hook to fetch uniform data for a specific driver
 * @param options Options for fetching uniform data
 * @returns Query result with uniform data
 */
export function useFetchUniform(options: FetchUniformOptions) {
  return useQuery<FetchUniformResponse>({
    queryKey: ["uniform", options],
    queryFn: async () => {
      try {
        const { data, error } = await supabase.functions.invoke("fetch-uniform", {
          body: options,
        })

        if (error) {
          throw new Error(`Error fetching uniform data: ${error.message}`)
        }

        return data as FetchUniformResponse
      } catch (error) {
        console.error("Error in useFetchUniform:", error)
        throw error
      }
    },
    enabled: !!options.driverId, // Only fetch if driverId is provided
  })
}
